import Prizes from './Prizes';

export default Prizes;
